export const site = {
    ref: 'AssistantAppsStream',
    captchaKey: 'fe066469-a02f-4827-b577-28ebaea300c8',
    kurt: {
        fullName: 'Kurt Lourens',
        nickName: 'Khaoz-Topsy',
        website: 'https://kurtlourens.com',
        twitter: 'https://twitter.com/KhaozTopsy',
        github: 'https://github.com/Khaoz-Topsy',
    },
    stream: {
        twitch: 'https://www.twitch.tv/khaoztopsy',
    },
    assistantApps: {
        name: 'AssistantApps',
        email: 'mailto:support@assistantapps.com',
        website: 'https://assistantapps.com',
        tools: 'https://tools.assistantapps.com',
        github: 'https://assistantapps.com/github',
        discord: 'https://assistantapps.com/discord',
        patreon: 'https://www.patreon.com/AssistantApps',
    }
}